import microuniversoApi from "app/api/microuniversoApi"
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse"
import { useAppSelector } from "app/redux/hooks"
import { ClienteCotacoesPerdidas, FiltroCotacoesPerdidas, TabelaCotacaoPerdida } from "app/types/CotacoesPerdidas"
import { IColuna } from "app/types/IColuna"
import { IOrcamento } from "app/types/IOrcamento"
import { Parametro } from "app/types/Parametro"
import { tratamentoErroPadrao } from "app/use-cases"
import { obterPermissao } from "app/use-cases/obterPermissao"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import { Dict } from "app/utils/Dict"
import globalMU from "globalMU"
import * as R from "ramda"
import React, { useEffect, useRef, useState } from "react"
import { substituirItemEmArray } from "substituirItemEmArray"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { PesquisarClienteContainer } from "../pesquisa-cliente/PesquisarClienteContainer"
import { PaginaPesquisaProdutoContainer } from "../pesquisa-produtos/PaginaPesquisaProdutoContainer"
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact"
import { CotacoesPerdidas } from "./CotacoesPerdidas"
import { ProdutoFiltrado } from "app/types/IProduto"
const Backbone = require('backbone')

export type CotacoesPerdidasContainerProps = {
    regiaoRenderizada: string
    clienteSelecionado?: ClienteCotacoesPerdidas
    produtosSelecionados?: ProdutoFiltrado[]
    foraOrcamento?: boolean
    apenasCotacoesPerdidas?: boolean
}

declare const window: any;

export const CotacoesPerdidasContainer = (props: CotacoesPerdidasContainerProps) => {
    const nomeGrid = "PESQUISAR_COTACOES_PERDIDAS"
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [parametros, setParametros] = useState<Parametro[]>([]);
    const [cotacoesPerdidas, setCotacoesPerdidas] = useState<PagedMessageResponse<TabelaCotacaoPerdida>>({});
    const [clienteSelecionado, setClienteSelecionado] = useState<ClienteCotacoesPerdidas>(props.clienteSelecionado ?? {})
    const [produtosSelecionados, setProdutosSelecionados] = useState<ProdutoFiltrado[]>(props.produtosSelecionados ?? [])
    const [apenasCotacoesPerdidas, setApenasCotacoesPerdidas] = useState<boolean>(props.apenasCotacoesPerdidas ?? true);
    const [permiteEngrenagemGrid, setPermiteEngrenagemGrid] = useState<boolean>(false)
    const [colunas, setColunas] = useState<IColuna[]>([]);
    const [tamanhoFonte, setTamanhoFonte] = useState<number>(0);


    const [mostrarComponente, setMostrarComponente] = useState(true)

    const onRenderizarCotacoesPerdidas = () => renderizarComponentReact(<CotacoesPerdidasContainer {...props} />, props.regiaoRenderizada, true)

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())

    const atualizarValoresParametros = async () => {
        await R.pipe(() => obterParametros({ nomes: ["CHAVE_MOVIMENTACAO_ORCAMENTO"] }),
            R.andThen(setParametros)
        )();
    };

    const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;


    const onPesquisarProduto = () => {
        setMostrarComponente(false)
        setCotacoesPerdidas({})

        renderizarComponentReact(<PaginaPesquisaProdutoContainer
            pesquisandoApenasParaFiltroProdutosLupa={true}
            chamadoParaInserirProdutoNoOrcamento={false}
            chamadoPeloTrocarProduto={false}
            adicionarProdutos={(produtosSelecionados) => {

                renderizarComponentReact(
                    <CotacoesPerdidasContainer {...props}
                        apenasCotacoesPerdidas={apenasCotacoesPerdidas}
                        clienteSelecionado={clienteSelecionado}
                        produtosSelecionados={produtosSelecionados.map(produto => ({
                            Codigo: produto.Codigo,
                            Descricao: produto.Descricao,
                            CodigoProduto: produto.CodigoProduto
                        }))} />, props.regiaoRenderizada, true)
            }}
            passos={passosInterno.current}
            desabilitarPesquisarHistorico
            esconderForaEstoque={true}
            ocultarBarraPesquisa={true}
            desabilitarInserirContinuar={true}
            onVoltar={onRenderizarCotacoesPerdidas}
            regiaoRenderizada={props.regiaoRenderizada} />, props.regiaoRenderizada, true)

    }

    const pesquisarCliente = () => {
        setMostrarComponente(false)
        setCotacoesPerdidas({})


        renderizarComponentReact(
            <PesquisarClienteContainer
                regiaoRenderizada={props.regiaoRenderizada} passos={passosInterno.current} onVoltar={onRenderizarCotacoesPerdidas} consultar
                onSelecionarClienteCallback={(cliente) => {
                    renderizarComponentReact(<CotacoesPerdidasContainer {...props}
                        apenasCotacoesPerdidas={apenasCotacoesPerdidas} produtosSelecionados={produtosSelecionados}
                        clienteSelecionado={{ Codigo: cliente.Codigo, Nome: cliente.Nome }} />, props.regiaoRenderizada, true)
                }}
            />, props.regiaoRenderizada, true)

    }

    const onListarCotacoesPerdidas = async (filtroCotacoesPerdidas: FiltroCotacoesPerdidas, apenasCotacao: boolean) => {
        try {
            globalMU.blockUI();

            const resposta = await microuniversoApi.CotacaoPerdida.Listar({
                ...filtroCotacoesPerdidas,
                IdentificadorOrcamento: apenasCotacao ? orcamento.IdentificadorOrcamento : null
            });
            if (resposta && !("HasErrors" in resposta)) {
                setCotacoesPerdidas(resposta)
            }

        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const obterDadosGrid = async () => {
        try {
            globalMU.blockUI();
            setPermiteEngrenagemGrid(await obterPermissao({ funcionalidade: "ORCAMENTO_ACESSO_ENGRENAGEM_GRID", acao: null }));
            const resposta = await microuniversoApi.Seguranca.obterDadosGrid("orçamento", nomeGrid)

            if (resposta != null) {
                setColunas(resposta.Colunas.filter(c => c.Nome != "Acoes"))
                setTamanhoFonte(resposta.TamanhoFonte);
            };
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI();
        }
    };

    const toggleColunaSelecionada = async (nomeColuna: string, selecionada: boolean) => {
        let coluna = { ...colunas.find((c) => c.Nome == nomeColuna) }
        coluna.Selecionada = selecionada
        const colunas_ = substituirItemEmArray(colunas,
            (coluna) => coluna.Nome == nomeColuna,
            coluna
        )
        setColunas(colunas_)
        await microuniversoApi.Seguranca.atualizarColunasGrid(colunas_, nomeGrid)
    };

    const onAlterarFonte = async (tamanho: number) => {
        globalMU.blockUI();
        try {
            await microuniversoApi.Usuario.alterarFonte(nomeGrid, tamanho);
            globalMU.unblockUI();
        } catch (e) {
            tratamentoErroPadrao(e);
            globalMU.unblockUI();
        }
    };

    const toggleSelecionarTodasColunas = async (selecionar: boolean) => {
        const colunas_ = colunas.map(c => ({ ...c, Selecionada: selecionar } as IColuna))
        setColunas(colunas_)

        await microuniversoApi.Seguranca.atualizarGrid({
            CodigoUsuario: globalMU.userIdForGrid(),
            Modulo: "Orcamento",
            Token: globalMU.token(),
            NomeGrid: nomeGrid,
            Colunas: colunas_
        })
    }

    const excluirCliente = () => {
        setClienteSelecionado({});
    }

    const onRemoverItem = (produto: ProdutoFiltrado) => {
        const index = produtosSelecionados.indexOf(produto);
        index > -1 && produtosSelecionados.splice(index, 1);
        setProdutosSelecionados([...produtosSelecionados]);
    };


    useEffect(() => {
        passosInterno.current.set("Cotações Perdidas", () => renderizarComponentReact(<CotacoesPerdidasContainer {...props} />, props.regiaoRenderizada, true))
        atualizarValoresParametros()
        obterDadosGrid()

        const executarFiltroInicial = () => {

            const filtros: FiltroCotacoesPerdidas = {
                NumeroPagina: 1,
                TamanhoPagina: 20,
                ApenasCotacaoPerdidaOrcamento: true,
                CodigosProdutos: []
            }

            const apenasCotacao = true

            onListarCotacoesPerdidas(filtros, apenasCotacao)
        }

        if (!props.foraOrcamento) {
            executarFiltroInicial()
        }
    }, [])


    return (

        <>


            {mostrarComponente && <>

                <Breadcrumb2Container
                    passos={passosInterno.current.keysToList()}
                    id="CotacoesPerdidasContainer"
                    exibirBotaoLimpar={false}
                    exibirBotaoVoltar={false}
                />

                <CotacoesPerdidas
                    foraOrcamento={props.foraOrcamento}
                    pesquisarApenasCotacaoPerdida={Object.values(orcamento)?.length === 0}
                    colunas={colunas}
                    produtos={produtosSelecionados}
                    cotacoes={cotacoesPerdidas}
                    mostrarNomeComoCodigo={valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C"}
                    apenasCotacoesPerdidas={apenasCotacoesPerdidas}
                    onAlterarApenasCotacoesPerdidas={(apenasCotacao) => {
                        setApenasCotacoesPerdidas(apenasCotacao)
                        setCotacoesPerdidas({})
                    }}
                    clienteSelecionado={clienteSelecionado}
                    permiteEngrenagemGrid={permiteEngrenagemGrid}
                    tamanhoFontePadrao={tamanhoFonte}
                    onPesquisarCliente={pesquisarCliente}
                    onPesquisarProduto={onPesquisarProduto}
                    onExcluirCliente={excluirCliente}
                    onRemoveItem={onRemoverItem}
                    onPesquisar={onListarCotacoesPerdidas}
                    onAlterarFonte={(fonte) => {
                        onAlterarFonte(fonte);
                        setTamanhoFonte(fonte);
                    }}
                    onToggleColunaSelecionada={toggleColunaSelecionada}
                    onToggleSelecionarTodasColunas={toggleSelecionarTodasColunas}
                    onPesquisarComPaginacao={onListarCotacoesPerdidas}
                />
            </>
            }
        </>
    )
} 
